import React from 'react';
import { Route, Switch } from 'react-router-dom';
import List from 'components/Applications/List';
import Show from 'components/Applications/Show';

export default class Applications extends React.Component {
  render = () => {
    const { match } = this.props;
    return (
      <div>
        <Switch>
          <Route exact path={match.url} component={List}/>
          <Route path={`${match.url}/:appNumber`} component={Show}/>
        </Switch>
      </div>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/Applications/index.js